<template>
  <el-col :span="12">

    <el-table
      :data="tableGrand"
      border
      style="width: 100%"
    >
      <el-table-column align="center" :label="title">
        <el-table-column
          prop="type"
          align="center"
          label="类型"
        />
        <el-table-column
          prop="num"
          align="center"
          label="总计"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="rate"
          align="center"
          label="占比"
          :formatter="consumeFormatter"
        />
      </el-table-column>
    </el-table>

    <todayEchart ref="grand" :title="''" />
  </el-col>
</template>
<script>
import { getRidData } from '@/api/statistics/user_remain'
import { scientificFormat } from '@/utils'
import TodayEchart from '@/views/config/spins-consume/compents/today-echart.vue'

export default {
  name: 'SpinRateChart',
  components: { TodayEchart },
  data() {
    return {
      title: '未付费',
      tableGrand: []
    }
  },
  methods: {
    async refresh(typ, queryParams) {
      queryParams.id = 1
      if (typ === 2) {
        this.title = '付费'
        queryParams.id = 2
      }
      let totalNum = 0
      return getRidData(queryParams).then(res => {
        totalNum = res.data[0].num
        const _tableGrand = []
        res.data[0].data.forEach(res => {
          const rate = (res.num / totalNum * 100).toFixed(4)
          _tableGrand.push({
            type: res.title,
            num: res.num,
            rate: rate
          })
        })
        this.tableGrand = _tableGrand
        this.$refs.grand.init(this.tableGrand)
        return totalNum
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }, consumeFormatter(row) {
      return row.rate + '%'
    }
  }
}
</script>

<style scoped>

</style>
